import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { HatcheriesService } from './hatcheries.service';
import { HatcheriesDTO } from './dto/hatcheries.dto';
import { AllHatcheriesResponseModel, HatcheriesRequest, HatcheriesResponseModel } from '@gtpl/shared-models/masters';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';



@ApiTags('hatcheries')
@Controller('hatcheries')
export class HatcheriesController {

    constructor(
        private hatcheriesService: HatcheriesService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createHatcheries')
    async createHatcheries(@Body() hatcheriesDto:HatcheriesDTO,isUpdate:boolean=false): Promise<HatcheriesResponseModel> {
    try {
        return await this.hatcheriesService.createHatcheries(hatcheriesDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(HatcheriesResponseModel, error);
      }
    }
    @Post('/updateHatcheries')
  async updateHatcheries(@Body() hatcheriesDto: HatcheriesDTO,@Req() request:Request): Promise<HatcheriesResponseModel> {
    try {
      console.log('update Hatcheries');hatcheriesDto
      console.log(request);
      return await this.hatcheriesService.createHatcheries(hatcheriesDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(HatcheriesResponseModel, error);
    }
  }
  @Post('/getAllHatcheries')
  // @UseGuards(AuthGuard('jwt'))
  async getAllHatcheries(@Body() req?:UserRequestDto): Promise<AllHatcheriesResponseModel> {
    try {
      return await this.hatcheriesService.getAllHatcheries(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllHatcheriesResponseModel, error);
    }
  }
  @Post('/activateOrDeactivateHatcheries')
  async activateOrDeactivateHatcheries(@Body() hatcheriesreq: HatcheriesRequest): Promise<HatcheriesResponseModel> {
      try {
          return await this.hatcheriesService.activateOrDeactivateHatcheries(hatcheriesreq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(HatcheriesResponseModel, err);
      }
  }
  @Post('/getAllActiveHatcheries')
  async getAllActiveHatcheries(@Req() request: Request): Promise<AllHatcheriesResponseModel> {
      try {
          return await this.hatcheriesService.getAllActiveHatcheries();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllHatcheriesResponseModel, error)
      }
  }
  @Post('/getHatcheriesById')
  async getHatcheriesById(@Body() hatcheriesreq: HatcheriesRequest): Promise<HatcheriesResponseModel> {
      try {
          return await this.hatcheriesService.getActiveHatcheriesById(hatcheriesreq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(HatcheriesResponseModel, err);
      }
  }
}



